<div class="externe-daten">
  @if (wohnung) {
    <cap-content-header>
      <cap-title>
        {{ "GWRWohnung" | translate }}: {{ wohnung.adresse | kompaktGwrGebaeudeeingangsadresse }} , {{ "EGID_EWID" | translate }}
        {{ wohnung.egid.value }}/{{ wohnung.ewid.value }}
      </cap-title>
    </cap-content-header>
  }

  @if (wohnung) {
    <div class="row mt-2">
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement label="Wohnungsflaeche">
          @if (wohnung.wohnungsflaeche) {
            <span>{{ wohnung.wohnungsflaeche | decimalHochkomma }}&nbsp;m²</span>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.wohnungsstatus | translate" label="Wohnungsstatus"></cap-kopfdatenelement>
        <cap-kopfdatenelement label="Stockwerk">
          @if (wohnung.stockwerk.stockwerkNummer) {
            {{ wohnung.stockwerk.stockwerkNummer }}. {{ wohnung.stockwerk.stockwerkBezeichnung | translate }}
          } @else {
            {{ wohnung.stockwerk.stockwerkBezeichnung | translate }}
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.anzahlZimmer" label="AnzahlZimmer"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.mehrgeschossig.toString() | translate" label="Mehrgeschossig"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.kuecheVorhanden.toString() | translate" label="KuecheVorhanden"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.adresse | kompaktGwrGebaeudeeingangsadresse" label="Adresse"></cap-kopfdatenelement>
      </div>
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement label="EGID_EWID">{{ wohnung.egid.value }}/{{ wohnung.ewid.value }}</cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.administrativeNummer" label="AdminWohnungsnummer"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.lageAufStockwerk" label="LageAufStockwerk"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.wohnungsnummer" label="Wohnungsnummer"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.baujahr | gwrBaujahrPeriodePipe: wohnung.bauperiode" label="Baujahr"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="wohnung.abbruchjahr" label="Abbruchjahr"></cap-kopfdatenelement>
      </div>
    </div>
    <cap-gwr-grundstueck-table [listLoader]="grundstueckListLoader">
      <div class="title-divider" name="title">
        <h2>{{ "BetroffeneGrundstücke" | translate }}</h2>
      </div>
    </cap-gwr-grundstueck-table>
  } @else {
    <cap-spinner-small [withBreadcrumb]="true"></cap-spinner-small>
  }
</div>

<ng-template #stockwerkBezeichnung>
  {{ wohnung.stockwerk.stockwerkBezeichnung | translate }}
</ng-template>
